import React from "react";
import { PageHero } from "../components/pageHero";
import { Cta } from "../components/cta";
import { Link } from "react-router-dom";

const Products = ({ data }) => {
  const page = data.ProductsPage;

  return (
    <>
      <PageHero
        title={page.heroTitle}
        subtitle={page.heroSubtitle}
        image="img/hero-products.jpg"
      />

      <div className="page-section product-intro">
        <div className="container">
          <div className="col-md-10 col-md-offset-1 text-center">
            <p className="lead">{page.intro}</p>
            <ul className="product-nav">
              {page.items.map((item) => (
                <li key={item.id}>
                  <a href={`#${item.id}`}>{item.name}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {page.items.map((item, index) => (
        <div
          key={item.id}
          id={item.id}
          className={`page-section product-section${index % 2 ? " alt" : ""}`}
        >
          <div className="container">
            <div className={`row vcenter${index % 2 ? " flip" : ""}`}>
              <div className="col-md-6 product-media">
                <img src={item.image} className="img-responsive framed" alt={item.name} />
              </div>
              <div className="col-md-6">
                <span className="eyebrow dark">{`0${index + 1}`}</span>
                <h2>{item.name}</h2>
                <p className="product-tagline">{item.tagline}</p>
                {item.paragraphs.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
                <ul className="check-list">
                  {item.bullets.map((b, i) => (
                    <li key={i}>{b}</li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="row product-detail">
              <div className="col-md-7">
                <h3>Specification</h3>
                <div className="spec-table">
                  {item.specs.map((s, i) => (
                    <div key={i} className="spec-row">
                      <span className="spec-label">{s.label}</span>
                      <span className="spec-value">{s.value}</span>
                    </div>
                  ))}
                </div>
                <Link to="/contact" className="btn btn-custom">
                  Enquire About {item.name}
                </Link>
              </div>
              <div className="col-md-5">
                <div className="product-thumbs">
                  {item.images.map((img, i) => (
                    <img key={i} src={img} className="img-responsive" alt={`${item.name} — ${i + 1}`} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="page-section process-section">
        <div className="container">
          <div className="col-md-10 col-md-offset-1 section-title text-center">
            <h2>{page.process.title}</h2>
          </div>
          <div className="card-grid process-grid">
            {page.process.steps.map((s, i) => (
              <div key={i} className="process-item">
                <span className="process-n">{s.n}</span>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Cta
        title="Ready for a price?"
        text="Send the material, thickness, finish, quantity and destination port. We answer with samples, a written offer and a loading date."
      />
    </>
  );
};

export default Products;
